import { Routes } from '@angular/router';

export const accountRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('@rma/public/accounts/activation'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/public/accounts/member-invitation'),
  },
  {
    path: '',
    loadChildren: () => import('@rma/public/accounts/login'),
  },
  {
    path: 'unsubscribe/:emailId',
    loadComponent: () => import('@rma/public/accounts/unsubscribe'),
  },
];
